import axios from 'axios'
import router from '../router';

export default {
    namespaced: true,
    state: {
        token: null,
        user: null,
        app_version: 'a240924_6',
        app_upgraded: false,
        showBNR: false,
    },
    getters: {
        authenticated(state) {
            return state.token && state.user;
        },
        user(state) {
            return state.user;
        },
        app_upgraded(state) {
            return state.app_upgraded;
        },
        showBNR(state) {
            return state.showBNR;
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_API_TOKEN(state, token) {
            state.user.api_token = token;
        },
        SET_APP_VERSION(state, version) {
            if (version !== state.app_version) {
              setTimeout(()=>{
                    state.app_upgraded = true;
              },500)
            }
        },
        SET_USER(state, user) {
            state.user = user;

        },
        SET_BNR(state, status) {
            state.showBNR = status;

        }
    },
    actions: {
        async Check(_, credentials) {
            let response = await axios.post('check/', credentials)
            if (response.data.success) {
                return response.data
            }
            return Promise.reject(response.data)

        },
        async Login({dispatch}, credentials) {
            let response = await axios.post('login/', credentials)
            if (response.data.success && response.data.data.token) {
                return dispatch('attempt', response.data.data.token)
            }
            return Promise.reject(response.data)

        },
        api_token({commit}, token) {
            commit('SET_API_TOKEN', token)

        },
        bnr({commit}, status) {
            commit('SET_BNR', status)

        },
        async attempt({commit, state}, token) {
            if (token) {
                commit('SET_TOKEN', token)
            }
            if (!state.token) {
                return
            }
            try {
                let response = await axios.get('user/')
                commit('SET_USER', response.data.data)
                commit('SET_APP_VERSION', response.data.data.settings.app_version)

            } catch (e) {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
                router.push({path: '/login'})
            }
        },
        Logout({commit}) {
            return axios.get('logout/').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            })
        }
    }
}
